<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      prominent
      flat
      v-if="$route.meta.showmenu != false"
    >
      <v-img
        alt="vvgi-logo"
        src="./assets/neuro-logo.svg"
        contain
        max-width="300"
        height="90"
        class="mt-5"
      ></v-img>
      <v-spacer></v-spacer>
      <span class="mt-11" color="primary">Vinnie</span>
    </v-app-bar>

    <v-main>
      <v-toolbar
        dense
        flat
        color="primary"
        v-if="$route.meta.showmenu != false"
      >
        <v-toolbar-items>
          <v-btn to="/" small color="primary" v-show="this.rechten && this.rechten != ''">Home</v-btn>
          <v-btn
            to="/Start"
            small
            color="primary"
            v-show="rechten && rechten.SessieStarten"
            >Start sessie</v-btn
          >
          <v-btn
            to="/Rapport/client"
            small
            color="primary"
            v-show="rechten && rechten.SessieStarten"
            >Cliëntrapport</v-btn
          >
          <v-btn
            to="/Rapport/totaal"
            small
            color="primary"
            v-show="rechten && rechten.RapportAlleSessies"
            >Totaalrapport</v-btn
          >
          <v-btn
            to="/Beheer"
            small
            color="primary"
            v-show="rechten && rechten.Admin"
            >Beheer</v-btn
          >
          <v-btn to="/Login" small color="primary" v-show="this.rechten && this.rechten != ''">Uitloggen</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <router-view />
    </v-main>
    <v-footer
      color="primary"
      v-show="$route.meta.showmenu != false"
      app
      class="justify-center white--text"
    >
      &copy; {{ new Date().getFullYear() }} - Vinnie - Centrum voor
      Neuropsychiatrie en Computus bv
    </v-footer>
  </v-app>
</template>

<script>
export default {
  components: {},
  data() {
    return { rechten: null };
  },
  methods: {
    getRechten: function () {
      this.$api.pRechtenGet().then((response) => {
        this.rechten = response.data[0];
      });
    },
    logout: function () {
      this.rechten = "";
    },
  },
  created: function () {
    this.getRechten();
    this.$root.$on("login", this.getRechten);
    this.$root.$on("logout", this.logout);
  },
};
</script>

<style>
</style>
